import React from 'react';
import {twMerge} from 'tailwind-merge';

import {AddSectionButton} from './AddSectionButton';
import {EmptySectionMessageNoMetrics} from './EmptyMessages';
import {PanelBankSections} from './PanelBankSections2';
import {useIsWorkspaceEmpty} from './useIsWorkspaceEmpty';

export const PanelBankSectionsContainer = ({
  isProjectReadOnly,
}: {
  isProjectReadOnly: boolean;
}) => {
  const isWorkspaceEmpty = useIsWorkspaceEmpty();

  if (isWorkspaceEmpty) {
    return (
      <div className="flex h-full w-full flex-col">
        <EmptySectionMessageNoMetrics />
        <div
          className={twMerge(
            'flex justify-end',
            'px-32 py-16',
            'border-t border-moon-300'
          )}>
          <AddSectionButton />
        </div>
      </div>
    );
  }

  return <PanelBankSections isProjectReadOnly={isProjectReadOnly} />;
};
